import { Link, useLocation } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { seoFor } from "@/lib/seo";
import { t } from "@/i18n";
import { eur, pct } from "@/lib/format";
import LanguageSwitcher from "@/components/LanguageSwitcher";

const IMG = "https://images.unsplash.com/photo-1577219491135-ce391730fb2c?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

function AboutPage() {
  const s = seoFor(useLocation().pathname);
  if (!s.body) return null;
  return (
    <section className="mx-auto w-full max-w-sm border-t pb-10 pt-8" data-testid="auth-about-section">
      <h2 className="text-base font-bold tracking-tight md:text-lg">{s.heading}</h2>
      <div className="mt-3 space-y-3 text-sm leading-relaxed text-muted-foreground">
        {s.body.map((p) => <p key={p.slice(0, 24)}>{p}</p>)}
      </div>
      <Link to="/" className="mt-4 inline-block text-sm font-semibold text-foreground underline-offset-4 hover:underline" data-testid="auth-about-home-link">{t("authShell.decouvrir_mymenuprofit")}</Link>
    </section>
  );
}

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-[1fr_1.1fr]">
      <div className="flex flex-col px-6 py-8 sm:px-12">
        <div className="flex items-center justify-between gap-2"><Link to="/"><Logo /></Link><LanguageSwitcher /></div>
        <div className="mx-auto flex w-full max-w-sm flex-1 flex-col justify-center py-12 fade-up">
          <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-muted-foreground">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
        </div>
        <AboutPage />
        <p className="text-xs text-muted-foreground">{t("common.mymenuprofit_l_intelligence_de_menu_pour_r")}</p>
      </div>
      <div className="relative hidden overflow-hidden lg:sticky lg:top-0 lg:block lg:h-screen">
        <img src={IMG} alt={t("authShell.chef_en_cuisine")} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/40 to-black/10" />
        <div className="absolute bottom-0 left-0 right-0 p-12 text-white">
          <p className="eyebrow !text-white/70">{t("authShell.rentabilite_de_menu")}</p>
          <p className="mt-3 max-w-lg text-3xl font-bold leading-tight tracking-tight">
            {t("authShell.combien_chaque_plat_vous_rapporte_t_il")} <span className="text-emerald-400">{t("landing.hero_title_highlight")}</span>{t("authShell.title_end")}
          </p>
          <div className="mt-8 grid max-w-lg grid-cols-3 gap-3">
            {[[pct(28.4), t("common.cout_matiere")], [`+${eur(1.5)}`, t("authShell.prix_conseille")], [pct(18), t("authShell.hausse_detectee")]].map(([v, l]) => (
              <div key={l} className="rounded-xl border border-white/15 bg-white/10 p-3 backdrop-blur-md">
                <p className="num text-lg font-semibold">{v}</p>
                <p className="text-xs text-white/70">{l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
